<script>
export default {
  name: 'UpgradeHighlight',
  props: {
    pageDescription: { type: String, required: true },
    highlightCopy: { type: String, required: true },
    supportNote: { type: String, required: true },
  },
  emits: ['go-billing', 'go-usage'],
};
</script>

<template>
  <section class="upgrade-highlight">
    <div class="flex items-start gap-3">
      <div class="space-y-2">
        <p class="text-sm text-slate-600 dark:text-slate-300">
          {{ highlightCopy }}
        </p>
        <p class="text-xs text-slate-500 dark:text-slate-400">
          {{ supportNote }}
        </p>
      </div>
    </div>
    <div class="flex flex-wrap gap-2">
      <woot-button variant="smooth" @click="$emit('go-billing')">
        {{ $t('UPGRADE_SETTINGS.CTA.GO_TO_BILLING') }}
      </woot-button>
      <woot-button variant="smooth" color-scheme="secondary" @click="$emit('go-usage')">
        {{ $t('UPGRADE_SETTINGS.CTA.GO_TO_USAGE') }}
      </woot-button>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.upgrade-highlight {
  @apply relative flex flex-col gap-6 overflow-hidden rounded-3xl border border-hilab/20 bg-white/90 p-6 shadow-sm transition-all duration-300 dark:border-slate-700/40 dark:bg-slate-800/90 md:flex-row md:items-center md:justify-between;
  background-image: linear-gradient(135deg, rgba(95, 116, 255, 0.08), rgba(255, 255, 255, 0));
}

.upgrade-highlight:hover {
  @apply shadow-md;
}
</style>


